// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"AgeRestrictedProductsModal_modalContainer__yWDTs","modalContent":"AgeRestrictedProductsModal_modalContent__i0sDO"};